import { useRef } from 'react';

export default function usePersistentFunction<T extends Function>(func: T): T {
  const funcRef = useRef<T>(func);
  return funcRef.current;
}
